import { string, shape, array, arrayOf } from "prop-types";

export const itemShape = shape({
  title: string,
  sectors: array,
  description: string,
  bodyContent: arrayOf(
    shape({ accordionTitle: string, accordionText: string }),
  ),
  buttonLink: shape({ text: string, href: string }),
});

export const itemsShape = arrayOf(itemShape);

export const filterShape = shape({ value: string, label: string });

export const filtersShape = arrayOf(filterShape);

export const dataShape = shape({
  title: string,
  filters: filtersShape,
  items: itemsShape,
});
